export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_REGISTER_INTEREST = 'USER_REGISTER_INTEREST';
export const USER_REGISTER_INTEREST_SUCCESS = 'USER_REGISTER_INTEREST_SUCCESS';
export const USER_REGISTER_INTEREST_FAIL = 'USER_REGISTER_INTEREST_FAIL';
export const USER_MARK_FAVOURITE = 'USER_MARK_FAVOURITE';
export const USER_SEND_FEEDBACK = 'USER_SEND_FEEDBACK';
export const USER_SEND_FEEDBACK_SUCCESS = 'USER_SEND_FEEDBACK_SUCCESS';
export const USER_SEND_FEEDBACK_FAIL = 'USER_SEND_FEEDBACK_FAIL';
export const USER_FEEDBACK_RESET = 'USER_FEEDBACK_RESET';
